import { ApiObjectService } from './api-object.service'

class DictionaryMountTypesService extends ApiObjectService {
    namespace = 'dictionary-mount-types'
}

export const dictionaryMountTypesService = new DictionaryMountTypesService()
